import { InfoTextConfigModel, ProductConfigProps } from "models/WebShop";
import { useState } from "react";

const InfoTextConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<InfoTextConfigModel>) => {

    const initialConfig = config?.[0];

    const [infoText, setInfoText] = useState(initialConfig?.text ?? "")

    const handleInputChange = (input:string) => {
        setInfoText(input);
        let newConfig: InfoTextConfigModel = {
                        text: input,
                        crmPublishLineId: initialConfig.crmPublishLineId,
                        crmProductId: initialConfig.crmProductId
                    }
                    handleOnChange([newConfig]);
                    handleFormValidation(true);
    } 

    return <>
    <div className="d-flex flex-column flex-md-row gap-4 mb-3 mb-md-4 align-items-center">
            <div className="order-md-last text-center">
                <img src="/min-bedrift-ill-beskrivelse.svg" width="800" height="270" alt="Beskrivelse av bedriften" className="img-fluid cc-mw-220"></img>
            </div>
            <div>
                <ul className="text-muted mb-0 cc-ul-spaced-1">
                    <li>En god firmabeskrivelse gjør profilen din mer levende, bygger tillit og kan bidra til at flere tar kontakt.</li>
                    <li>Presenter bedriften på en engasjerende måte.</li>
                    <li>Forklar hva bedriften tilbyr og hva som gjør dere unike. </li>
                </ul>
            </div>
        </div>
        <textarea className="form-control border-primary border-opacity-50 mb-2" id="description" aria-label="Beskrivelse av bedriften" maxLength={1000} onChange={(e) => handleInputChange(e.target.value)} placeholder="Beskriv din bedrifts virksomhet og fordelene ved å velge din bedrift…" style={{overflow: "hidden", resize: "none", height: "300px"}} value={infoText}></textarea>
        <p className="text-muted mb-0 cc-fs-xs"><span id="charCounter">{infoText.length} / 1000</span> tegn. Teksten vises på din bedrifts infoside.
            Forkortet tekst vises også i din oppføring på resultatsider (ikke i mobilvisning). NB! Linjeskift vil ikke bli bevart.</p>
    </>

}

export default InfoTextConfig;